import { Gift } from 'lucide-react';

import { TIPOS_BONUS } from '../bonus.api';
import { BonusSolicitudesPage } from './bonus-solicitudes-page';

/**
 * Bonus → Canje (`/bonus/canje`).
 *
 * Puerto de `Bonus::exchange`: los canjes de puntos
 * (`loyalty/api/v2/Exchange/card`) registrados por el flujo de venta.
 */
export function BonusCanjePage() {
  return (
    <BonusSolicitudesPage
      eyebrow="Bonus"
      titulo="Canje"
      descripcion="Canjes de puntos registrados contra el servicio de Bonus, con el detalle enviado y la respuesta de Primax."
      tipo={TIPOS_BONUS.canje}
      mostrarEnviados
      icono={Gift}
    />
  );
}
